
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire244a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire244a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1XhrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c8d57d3d0deb73$export$2e2bcd8739ae039);

var $8FBvR = parcelRequire("8FBvR");
const $16c8d57d3d0deb73$var$getDefaultParam = (paramName)=>{
    switch(paramName){
        case 'organization':
            return (0, $8FBvR.organizationSelector)();
        case 'patientId':
            return (0, $8FBvR.patientIdSelector)();
        case 'patientSer':
            return (0, $8FBvR.patientSerSelector)();
        case 'organizationId':
            return (0, $8FBvR.organizationIdSelector)();
    }
};
var $16c8d57d3d0deb73$export$2e2bcd8739ae039 = $16c8d57d3d0deb73$var$getDefaultParam;

});
parcelRegister("8FBvR", function(module, exports) {

$parcel$export(module.exports, "verifyDisabled", () => $64ff4053573ab001$export$94ca4fa056e6df83);
$parcel$export(module.exports, "pageSelector", () => $64ff4053573ab001$export$912099cf673aaa36);
$parcel$export(module.exports, "organizationSelector", () => $64ff4053573ab001$export$3b0cadee2e474bed);
$parcel$export(module.exports, "patientIdSelector", () => $64ff4053573ab001$export$5e71298ee9890971);
$parcel$export(module.exports, "patientSerSelector", () => $64ff4053573ab001$export$1e847a9a7d842134);
$parcel$export(module.exports, "configSelector", () => $64ff4053573ab001$export$c4eab2544a80bbf);
$parcel$export(module.exports, "meSelector", () => $64ff4053573ab001$export$2ee062cf7d916851);
$parcel$export(module.exports, "settingsSelector", () => $64ff4053573ab001$export$3edecab98d698790);
$parcel$export(module.exports, "settingsLoadedSelector", () => $64ff4053573ab001$export$359575c2088e79bd);
$parcel$export(module.exports, "documentIdSelector", () => $64ff4053573ab001$export$82fe8d2349bc42f1);
$parcel$export(module.exports, "documentTypeSelector", () => $64ff4053573ab001$export$81e672a345b7fda7);
$parcel$export(module.exports, "settingsPageSelector", () => $64ff4053573ab001$export$f6e628a374dc7941);
$parcel$export(module.exports, "showOverlaySelector", () => $64ff4053573ab001$export$670ef761bea9ff63);
$parcel$export(module.exports, "paramSelector", () => $64ff4053573ab001$export$4e02e87e243576);
$parcel$export(module.exports, "organizationIdSelector", () => $64ff4053573ab001$export$e92b0df43b477df5);
$parcel$export(module.exports, "organizationSlugSelector", () => $64ff4053573ab001$export$2317734504816e0b);

var $eWjQq = parcelRequire("eWjQq");

var $eGMym = parcelRequire("eGMym");
const $64ff4053573ab001$var$createSelector = (path, defaultValue)=>(0, $eGMym.default)(path, defaultValue);
const $64ff4053573ab001$export$94ca4fa056e6df83 = $64ff4053573ab001$var$createSelector('app.verifyDisabled');
const $64ff4053573ab001$export$912099cf673aaa36 = $64ff4053573ab001$var$createSelector('app.page');
const $64ff4053573ab001$export$3b0cadee2e474bed = $64ff4053573ab001$var$createSelector('app.params.organization');
const $64ff4053573ab001$export$5e71298ee9890971 = $64ff4053573ab001$var$createSelector('app.params.patient');
const $64ff4053573ab001$export$1e847a9a7d842134 = $64ff4053573ab001$var$createSelector('app.patient.ser');
const $64ff4053573ab001$export$c4eab2544a80bbf = $64ff4053573ab001$var$createSelector('app.config', {});
const $64ff4053573ab001$export$2ee062cf7d916851 = $64ff4053573ab001$var$createSelector('app.me');
const $64ff4053573ab001$export$3edecab98d698790 = $64ff4053573ab001$var$createSelector('app.settings');
const $64ff4053573ab001$export$359575c2088e79bd = $64ff4053573ab001$var$createSelector('app.settingsLoaded');
const $64ff4053573ab001$export$82fe8d2349bc42f1 = $64ff4053573ab001$var$createSelector('app.params.documentId');
const $64ff4053573ab001$export$81e672a345b7fda7 = $64ff4053573ab001$var$createSelector('app.params.documentType');
const $64ff4053573ab001$export$f6e628a374dc7941 = $64ff4053573ab001$var$createSelector('app.params.page', 'main');
const $64ff4053573ab001$export$670ef761bea9ff63 = $64ff4053573ab001$var$createSelector('app.showOverlay');
const $64ff4053573ab001$export$4e02e87e243576 = (param, defaultValue)=>$64ff4053573ab001$var$createSelector(`app.params.${param}`, defaultValue);
const $64ff4053573ab001$export$e92b0df43b477df5 = (state = (0, $eWjQq.store).getState())=>{
    const me = $64ff4053573ab001$export$2ee062cf7d916851(state);
    const { id: id } = (me || {
        organizations: []
    }).organizations.find(({ slug: slug })=>$64ff4053573ab001$export$3b0cadee2e474bed(state) === slug) || {};
    if (id) return id;
    if (me) return me.organizations[0].id;
};
const $64ff4053573ab001$export$2317734504816e0b = (state = (0, $eWjQq.store).getState())=>{
    const me = $64ff4053573ab001$export$2ee062cf7d916851(state);
    const { slug: slug } = (me || {
        organizations: []
    }).organizations.find(({ slug: slug })=>$64ff4053573ab001$export$3b0cadee2e474bed(state) === slug) || {};
    if (slug) return slug;
    if (me) return me.organizations[0].slug;
};

});
parcelRegister("eWjQq", function(module, exports) {

$parcel$export(module.exports, "store", () => $ae05e02bf59e754c$export$6f57813fe9f31bf9);

var $eShmq = parcelRequire("eShmq");

var $eNuyV = parcelRequire("eNuyV");

var $eGtl3 = parcelRequire("eGtl3");

var $kJGHq = parcelRequire("kJGHq");

var $jJlgu = parcelRequire("jJlgu");
// Sets up a Chrome extension for time travel debugging.
// See https://github.com/zalmoxisus/redux-devtools-extension for more information.
const $ae05e02bf59e754c$var$devCompose = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $eShmq.compose);
const $ae05e02bf59e754c$export$6f57813fe9f31bf9 = (0, $eShmq.createStore)((0, $eShmq.combineReducers)({
    app: $eGtl3.default,
    http: $kJGHq.default,
    toasts: $jJlgu.default
}), $ae05e02bf59e754c$var$devCompose((0, $eShmq.applyMiddleware)((0, $eNuyV.default))));

});
parcelRegister("eShmq", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ad4393542232627c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $ad4393542232627c$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $ad4393542232627c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $ad4393542232627c$export$9ff26e0402cc7b7);

var $d49SP = parcelRequire("d49SP");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d49SP.default)((0, $d49SP.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("eNuyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5d5956ce0b399b$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;

});

parcelRegister("eGtl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab0bbef82a3d9b93$export$2e2bcd8739ae039);

var $fp8Uu = parcelRequire("fp8Uu");
const $ab0bbef82a3d9b93$var$INITIAL_STATE = {};
const $ab0bbef82a3d9b93$var$showOverlay = (state, { show: show })=>({
        ...state,
        showOverlay: show
    });
const $ab0bbef82a3d9b93$var$updatePage = (state, { page: page, params: params, query: query })=>({
        ...state,
        page: page,
        params: params,
        query: query
    });
const $ab0bbef82a3d9b93$var$updateConfig = (state, { config: config })=>({
        ...state,
        config: config
    });
const $ab0bbef82a3d9b93$var$updateSettings = (state, { settings: settings })=>({
        ...state,
        settings: settings,
        settingsLoaded: true
    });
const $ab0bbef82a3d9b93$var$updateMe = (state, { me: me })=>({
        ...state,
        me: me
    });
const $ab0bbef82a3d9b93$var$updatePatient = (state, { patient: patient })=>({
        ...state,
        patient: patient
    });
const $ab0bbef82a3d9b93$var$verifyDisabled = (state, { disabled: disabled })=>({
        ...state,
        verifyDisabled: disabled
    });
const $ab0bbef82a3d9b93$var$reducers = {
    [(0, $fp8Uu.UPDATE_PAGE)]: $ab0bbef82a3d9b93$var$updatePage,
    [(0, $fp8Uu.UPDATE_CONFIG)]: $ab0bbef82a3d9b93$var$updateConfig,
    [(0, $fp8Uu.UPDATE_SETTINGS)]: $ab0bbef82a3d9b93$var$updateSettings,
    [(0, $fp8Uu.UPDATE_ME)]: $ab0bbef82a3d9b93$var$updateMe,
    [(0, $fp8Uu.UPDATE_PATIENT)]: $ab0bbef82a3d9b93$var$updatePatient,
    [(0, $fp8Uu.SHOW_OVERLAY)]: $ab0bbef82a3d9b93$var$showOverlay,
    [(0, $fp8Uu.VERIFY_DISABLED)]: $ab0bbef82a3d9b93$var$verifyDisabled
};
const $ab0bbef82a3d9b93$var$app = (state = $ab0bbef82a3d9b93$var$INITIAL_STATE, action)=>($ab0bbef82a3d9b93$var$reducers[action.type] || ((state)=>state))(state, action);
var $ab0bbef82a3d9b93$export$2e2bcd8739ae039 = $ab0bbef82a3d9b93$var$app;

});
parcelRegister("fp8Uu", function(module, exports) {

$parcel$export(module.exports, "UPDATE_CONFIG", () => $b3701a32abace423$export$b36bed5c06ca1f9b);
$parcel$export(module.exports, "UPDATE_ME", () => $b3701a32abace423$export$1f3634c85f4bf706);
$parcel$export(module.exports, "UPDATE_SETTINGS", () => $b3701a32abace423$export$da91ee1924d359b9);
$parcel$export(module.exports, "UPDATE_PAGE", () => $b3701a32abace423$export$5744b2ac2f7f4850);
$parcel$export(module.exports, "UPDATE_PATIENT", () => $b3701a32abace423$export$f6cdc6e4a4a3c80a);
$parcel$export(module.exports, "SHOW_OVERLAY", () => $b3701a32abace423$export$5d387504cf09eee4);
$parcel$export(module.exports, "VERIFY_DISABLED", () => $b3701a32abace423$export$390d3a71c3b3b404);
const $b3701a32abace423$export$b36bed5c06ca1f9b = 'UPDATE_CONFIG';
const $b3701a32abace423$export$1f3634c85f4bf706 = 'UPDATE_ME';
const $b3701a32abace423$export$da91ee1924d359b9 = 'UPDATE_SETTINGS';
const $b3701a32abace423$export$5744b2ac2f7f4850 = 'UPDATE_PAGE';
const $b3701a32abace423$export$f6cdc6e4a4a3c80a = 'UPDATE_PATIENT';
const $b3701a32abace423$export$5d387504cf09eee4 = 'SHOW_OVERLAY';
const $b3701a32abace423$export$390d3a71c3b3b404 = 'VERIFY_DISABLED';

});


parcelRegister("kJGHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f18921d85dad501c$export$2e2bcd8739ae039);

var $hUF7r = parcelRequire("hUF7r");
const $f18921d85dad501c$var$shouldSkip = (state, name, request)=>state[name]?.request !== request || state[name]?.abortController?.signal?.aborted;
const $f18921d85dad501c$var$requestStarted = (state, { name: name, method: method, url: url, options: options, abortController: abortController, request: request })=>{
    state[name]?.abortController?.abort(); // Abort older request
    return {
        ...state,
        [name]: {
            name: name,
            method: method,
            url: url,
            options: options,
            abortController: abortController,
            request: request
        }
    };
};
const $f18921d85dad501c$var$requestCompleted = (state, { dataType: dataType, name: name, response: response, request: request, data: data, status: status, ok: ok })=>$f18921d85dad501c$var$shouldSkip(state, name, request) ? state : {
        ...state,
        [name]: {
            ...state[name],
            dataType: dataType,
            response: response,
            data: data,
            status: status,
            ok: ok,
            completed: true
        }
    };
const $f18921d85dad501c$var$requestErrored = (state, { name: name, error: error, response: response, request: request, status: status })=>{
    if ($f18921d85dad501c$var$shouldSkip(state, name, request)) return state;
    console.error('HTTP Request Error', error?.message, error?.stack);
    return {
        ...state,
        [name]: {
            ...state[name],
            error: error,
            response: response,
            status: status,
            completed: true
        }
    };
};
const $f18921d85dad501c$var$requestProcessed = (state, { name: name })=>({
        ...state,
        [name]: {
            ...state[name],
            processed: true
        }
    });
const $f18921d85dad501c$var$requestFlush = (state, { name: name })=>({
        ...state,
        [name]: undefined
    });
const $f18921d85dad501c$var$reducers = {
    [(0, $hUF7r.REQUEST_STARTED)]: $f18921d85dad501c$var$requestStarted,
    [(0, $hUF7r.REQUEST_COMPLETED)]: $f18921d85dad501c$var$requestCompleted,
    [(0, $hUF7r.REQUEST_ERRORED)]: $f18921d85dad501c$var$requestErrored,
    [(0, $hUF7r.REQUEST_PROCESSED)]: $f18921d85dad501c$var$requestProcessed,
    [(0, $hUF7r.REQUEST_FLUSH)]: $f18921d85dad501c$var$requestFlush
};
const $f18921d85dad501c$var$http = (state = {}, action)=>($f18921d85dad501c$var$reducers[action.type] || ((state)=>state))(state, action);
var $f18921d85dad501c$export$2e2bcd8739ae039 = $f18921d85dad501c$var$http;

});
parcelRegister("hUF7r", function(module, exports) {

$parcel$export(module.exports, "REQUEST_STARTED", () => $d0a78ffffee2fef9$export$ff4d0411b2a2ac08);
$parcel$export(module.exports, "REQUEST_COMPLETED", () => $d0a78ffffee2fef9$export$c60bf1ab44b97dcc);
$parcel$export(module.exports, "REQUEST_ERRORED", () => $d0a78ffffee2fef9$export$e73aa3482f2ac04f);
$parcel$export(module.exports, "REQUEST_PROCESSED", () => $d0a78ffffee2fef9$export$8b5fe4c7089c9453);
$parcel$export(module.exports, "REQUEST_FLUSH", () => $d0a78ffffee2fef9$export$7abc8f0a49c7c751);
const $d0a78ffffee2fef9$export$ff4d0411b2a2ac08 = 'http-request';
const $d0a78ffffee2fef9$export$c60bf1ab44b97dcc = 'http-completed';
const $d0a78ffffee2fef9$export$e73aa3482f2ac04f = 'http-errored';
const $d0a78ffffee2fef9$export$8b5fe4c7089c9453 = 'http-processed';
const $d0a78ffffee2fef9$export$7abc8f0a49c7c751 = 'http-flush';

});


parcelRegister("jJlgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d2b7166913f0fd$export$2e2bcd8739ae039);

var $4gjhp = parcelRequire("4gjhp");

var $ivRuz = parcelRequire("ivRuz");

var $jIFAb = parcelRequire("jIFAb");
parcelRequire("57sxF");
var $dgn0U = parcelRequire("dgn0U");
const $e5d2b7166913f0fd$var$INITIAL_STATE = {};
const $e5d2b7166913f0fd$var$addToast = (state, { message: message, color: color, id: id, state: toastState })=>({
        ...state,
        toasts: (0, $jIFAb.default)(state.toasts || [], (toast)=>toast.id === id, {
            message: message,
            color: color,
            id: id,
            state: toastState
        })
    });
const $e5d2b7166913f0fd$var$updateToast = (state, { id: id, state: toastState })=>{
    const toast = state.toasts?.find((toast)=>toast.id === id);
    return {
        ...state,
        toasts: toast ? (0, $dgn0U.default)(state.toasts, toast, {
            ...toast,
            state: toastState
        }) : []
    };
};
const $e5d2b7166913f0fd$var$clearToast = (state, { id: id })=>({
        ...state,
        toasts: (0, $ivRuz.default)(state.toasts || [], (toast)=>toast.id === id)
    });
const $e5d2b7166913f0fd$var$reducers = {
    [(0, $4gjhp.ADD_TOAST)]: $e5d2b7166913f0fd$var$addToast,
    [(0, $4gjhp.CLEAR_TOAST)]: $e5d2b7166913f0fd$var$clearToast,
    [(0, $4gjhp.UPDATE_TOAST)]: $e5d2b7166913f0fd$var$updateToast
};
const $e5d2b7166913f0fd$var$toasts = (state = $e5d2b7166913f0fd$var$INITIAL_STATE, action)=>($e5d2b7166913f0fd$var$reducers[action.type] || ((state)=>state))(state, action);
var $e5d2b7166913f0fd$export$2e2bcd8739ae039 = $e5d2b7166913f0fd$var$toasts;

});
parcelRegister("4gjhp", function(module, exports) {

$parcel$export(module.exports, "ADD_TOAST", () => $31a79c9689763b20$export$be6101a96815ead4);
$parcel$export(module.exports, "UPDATE_TOAST", () => $31a79c9689763b20$export$45ff11e0aa582749);
$parcel$export(module.exports, "CLEAR_TOAST", () => $31a79c9689763b20$export$9a9d6a0c0c844b20);
const $31a79c9689763b20$export$be6101a96815ead4 = 'ADD_TOAST';
const $31a79c9689763b20$export$45ff11e0aa582749 = 'UPDATE_TOAST';
const $31a79c9689763b20$export$9a9d6a0c0c844b20 = 'CLEAR_TOAST';

});

parcelRegister("ivRuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7a49da8d55ceef4$export$2e2bcd8739ae039);

var $kQ0MG = parcelRequire("kQ0MG");
// @param {Function} test Accepts value to test, returns true if matches or false if doesn't.
const $d7a49da8d55ceef4$var$removeValueMatching = (arr, test)=>{
    const value = arr.find(test);
    return (0, $kQ0MG.default)(arr, value);
};
var $d7a49da8d55ceef4$export$2e2bcd8739ae039 = $d7a49da8d55ceef4$var$removeValueMatching;

});
parcelRegister("kQ0MG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2b945afa476a979$export$2e2bcd8739ae039);

var $5tEcj = parcelRequire("5tEcj");
const $f2b945afa476a979$var$removeValue = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index === -1) return [
        ...arr
    ];
    return (0, $5tEcj.default)(arr, index, 1);
};
var $f2b945afa476a979$export$2e2bcd8739ae039 = $f2b945afa476a979$var$removeValue;

});
parcelRegister("5tEcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fced79926749a50$export$2e2bcd8739ae039);
const $3fced79926749a50$var$splice = (arr, index, numberToRemove = 0, ...newValues)=>{
    if (index < 0 || index >= arr.length) throw new Error('Index for splicing must be greater than zero and less than the max index of the array.');
    return [
        ...arr.slice(0, index),
        ...newValues,
        ...arr.slice(index + numberToRemove)
    ];
};
var $3fced79926749a50$export$2e2bcd8739ae039 = $3fced79926749a50$var$splice;

});



parcelRegister("jIFAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5b261d545779792$export$2e2bcd8739ae039);

var $dgn0U = parcelRequire("dgn0U");
const $e5b261d545779792$var$replaceValueMatching = (arr, test, newValue)=>{
    const value = arr.find(test);
    return (0, $dgn0U.default)(arr, value, newValue);
};
var $e5b261d545779792$export$2e2bcd8739ae039 = $e5b261d545779792$var$replaceValueMatching;

});
parcelRegister("dgn0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a7e9f0762db4167$export$2e2bcd8739ae039);

var $5tEcj = parcelRequire("5tEcj");
// If valueToReplace is not present, newValue will be added to the end of the array.
const $9a7e9f0762db4167$var$replaceValue = (arr, valueToReplace, newValue)=>{
    const index = arr.indexOf(valueToReplace);
    if (index === -1) return [
        ...arr,
        newValue
    ];
    return (0, $5tEcj.default)(arr, index, 1, newValue);
};
var $9a7e9f0762db4167$export$2e2bcd8739ae039 = $9a7e9f0762db4167$var$replaceValue;

});


parcelRegister("57sxF", function(module, exports) {

$parcel$export(module.exports, "distinct", () => (parcelRequire("jI9i2")).default);
$parcel$export(module.exports, "mapByKey", () => (parcelRequire("i2vWO")).default);
$parcel$export(module.exports, "removeValue", () => (parcelRequire("kQ0MG")).default);
$parcel$export(module.exports, "removeValueMatching", () => (parcelRequire("ivRuz")).default);
$parcel$export(module.exports, "replaceValue", () => (parcelRequire("dgn0U")).default);

var $jI9i2 = parcelRequire("jI9i2");

var $i2vWO = parcelRequire("i2vWO");

var $kQ0MG = parcelRequire("kQ0MG");

var $ivRuz = parcelRequire("ivRuz");

var $dgn0U = parcelRequire("dgn0U");

var $5tEcj = parcelRequire("5tEcj");

});
parcelRegister("jI9i2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5995528b19ab793$export$2e2bcd8739ae039);
const $e5995528b19ab793$var$distinct = (arr)=>arr.reduce((result, value)=>result.includes(value) ? result : [
            ...result,
            value
        ], []);
var $e5995528b19ab793$export$2e2bcd8739ae039 = $e5995528b19ab793$var$distinct;

});

parcelRegister("i2vWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d22132058c7ab562$export$2e2bcd8739ae039);
const $d22132058c7ab562$var$mapByKey = (arr, key = 'id', transform = (a)=>a)=>arr.reduce((result, obj)=>Object.assign(result, {
            [obj[key]]: transform(obj)
        }), {});
var $d22132058c7ab562$export$2e2bcd8739ae039 = $d22132058c7ab562$var$mapByKey;

});




parcelRegister("eGMym", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab1aa69c9d6027db$export$2e2bcd8739ae039);
parcelRequire("cdK69");
var $gD1Wi = parcelRequire("gD1Wi");
parcelRequire("4Yz9y");
var $kYBQo = parcelRequire("kYBQo");

var $eWjQq = parcelRequire("eWjQq");
const $ab1aa69c9d6027db$var$createSelector = (path, defaultValue)=>(state = (0, $eWjQq.store).getState())=>(0, $gD1Wi.default)(state || (0, $kYBQo.default)().getState(), path) || defaultValue;
var $ab1aa69c9d6027db$export$2e2bcd8739ae039 = $ab1aa69c9d6027db$var$createSelector;

});
parcelRegister("cdK69", function(module, exports) {

$parcel$export(module.exports, "clone", () => (parcelRequire("7Haww")).default);
$parcel$export(module.exports, "deepEquals", () => (parcelRequire("gQPVU")).default);
$parcel$export(module.exports, "safeSelect", () => (parcelRequire("gD1Wi")).default);
$parcel$export(module.exports, "valuesMatch", () => (parcelRequire("2bgYZ")).default);

var $7Haww = parcelRequire("7Haww");

var $gQPVU = parcelRequire("gQPVU");

var $fi775 = parcelRequire("fi775");

var $gD1Wi = parcelRequire("gD1Wi");

var $2bgYZ = parcelRequire("2bgYZ");

});
parcelRegister("7Haww", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a4b6503508fcc1$export$2e2bcd8739ae039);
const $59a4b6503508fcc1$var$clone = (obj, deep = true)=>{
    if (typeof obj !== 'object' || !obj || obj === '') return obj; // primitive or function, can't clone
    if (Symbol.iterator in obj) return Array.prototype.map.call(obj, (value)=>$59a4b6503508fcc1$var$clone(value, deep));
    const newObj = {};
    if (obj.clone && typeof obj.clone === 'function') return obj.clone();
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = deep ? $59a4b6503508fcc1$var$clone(obj[key], deep) : obj[key];
    return newObj;
};
var $59a4b6503508fcc1$export$2e2bcd8739ae039 = $59a4b6503508fcc1$var$clone;

});

parcelRegister("gQPVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c449c97970f0cac9$export$2e2bcd8739ae039);
const $c449c97970f0cac9$var$deepEquals = (a, b)=>a === b || typeof a === 'object' && typeof b === 'object' && Object.keys(a).length === Object.keys(b).length && Object.entries(a).every(([key, aValue])=>$c449c97970f0cac9$var$deepEquals(aValue, b[key]));
var $c449c97970f0cac9$export$2e2bcd8739ae039 = $c449c97970f0cac9$var$deepEquals;

});

parcelRegister("fi775", function(module, exports) {
const $b21e0dfcbc41adc9$var$freezableTypes = [
    'object',
    'function'
];
const $b21e0dfcbc41adc9$var$deepFreeze = (obj)=>{
    if (Object.isFrozen(obj) || !$b21e0dfcbc41adc9$var$freezableTypes.includes(typeof obj)) return obj;
    if (Symbol.iterator in obj) return Object.freeze(Array.prototype.map.call(obj, (value)=>$b21e0dfcbc41adc9$var$deepFreeze(value)));
    return Object.freeze(Object.entries(obj).reduce((result, [key, value])=>Object.assign(result, {
            [key]: $b21e0dfcbc41adc9$var$deepFreeze(value)
        }), {}));
};
var $b21e0dfcbc41adc9$export$2e2bcd8739ae039 = $b21e0dfcbc41adc9$var$deepFreeze;

});

parcelRegister("gD1Wi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b1caf025d8f006$export$2e2bcd8739ae039);
const $c1b1caf025d8f006$var$safeSelect = (obj, path)=>{
    const parts = path.split(/\./g);
    let current = obj;
    while(current && parts.length)current = current[parts.shift()];
    return current;
};
var $c1b1caf025d8f006$export$2e2bcd8739ae039 = $c1b1caf025d8f006$var$safeSelect;

});

parcelRegister("2bgYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1969c847f749bc1a$export$2e2bcd8739ae039);
const $1969c847f749bc1a$var$valuesMatch = (a, b)=>a === b || typeof a === 'object' && typeof b === 'object' && Object.keys(a).length === Object.keys(b).length && Object.entries(a).every(([key, value])=>value === b[key]);
var $1969c847f749bc1a$export$2e2bcd8739ae039 = $1969c847f749bc1a$var$valuesMatch;

});


parcelRegister("4Yz9y", function(module, exports) {

$parcel$export(module.exports, "getStore", () => (parcelRequire("kYBQo")).default);
$parcel$export(module.exports, "setStore", () => (parcelRequire("bFTPb")).default);

var $kYBQo = parcelRequire("kYBQo");

var $bFTPb = parcelRequire("bFTPb");

});
parcelRegister("kYBQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f456c44efbe64bc9$export$2e2bcd8739ae039);

var $6OKUw = parcelRequire("6OKUw");
const $f456c44efbe64bc9$var$getStore = ()=>(0, $6OKUw.default).store;
var $f456c44efbe64bc9$export$2e2bcd8739ae039 = $f456c44efbe64bc9$var$getStore;

});
parcelRegister("6OKUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f6bcd1498deb2f2$export$2e2bcd8739ae039);
// This should only be used by getStore() and setStore.
// Don't export in store/index.js
const $4f6bcd1498deb2f2$var$storeManager = {
    store: undefined
};
var $4f6bcd1498deb2f2$export$2e2bcd8739ae039 = $4f6bcd1498deb2f2$var$storeManager;

});


parcelRegister("bFTPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fed39d27f8417f$export$2e2bcd8739ae039);

var $6OKUw = parcelRequire("6OKUw");
const $87fed39d27f8417f$var$setStore = (store)=>(0, $6OKUw.default).store = store;
var $87fed39d27f8417f$export$2e2bcd8739ae039 = $87fed39d27f8417f$var$setStore;

});





parcelRegister("8dxZ0", function(module, exports) {

$parcel$export(module.exports, "defaultResponseHandler", () => $5fb9e5f2b72fb5e6$export$a16fabbea479f58a);
$parcel$export(module.exports, "default", () => $5fb9e5f2b72fb5e6$export$2e2bcd8739ae039);

var $aW9Iw = parcelRequire("aW9Iw");

var $4H3d6 = parcelRequire("4H3d6");
parcelRequire("cdK69");
var $gQPVU = parcelRequire("gQPVU");
parcelRequire("4Yz9y");
var $kYBQo = parcelRequire("kYBQo");
function $5fb9e5f2b72fb5e6$var$_defineProperty(e, r, t) {
    return (r = $5fb9e5f2b72fb5e6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5fb9e5f2b72fb5e6$var$_toPropertyKey(t) {
    var i = $5fb9e5f2b72fb5e6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5fb9e5f2b72fb5e6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * @typedef {{
 *   name?: string,
 *   query: Object<string, any>,
 *   body?: string|Blob|Object<string, any>,
 *   pathParams?: Object<string, string>
 * }} HttpOptions
 */ const $5fb9e5f2b72fb5e6$var$requestsMatch = (request, method, url, options)=>request?.method === method && request?.url === url && (0, $gQPVU.default)(request?.options, options);
class $5fb9e5f2b72fb5e6$export$5acc8102a0306bf8 extends Error {
    constructor(message, { status: status, method: method, url: url, options: options, response: response, error: error, data: data, dataType: dataType }){
        super(message);
        this.status = status;
        this.method = method;
        this.url = url;
        this.options = options;
        this.response = response;
        this.error = error;
        this.data = data;
        this.dataType = dataType;
    }
}
const $5fb9e5f2b72fb5e6$export$a16fabbea479f58a = ({ method: method, url: url, options: options, response: response = null, error: error = null, data: data = null, dataType: dataType = null })=>{
    if (response?.ok) return;
    throw new $5fb9e5f2b72fb5e6$export$5acc8102a0306bf8(response?.statusText || 'Error', response?.status, method, url, options, error, data, dataType);
};
class $5fb9e5f2b72fb5e6$export$2a5b27776dbece47 {
    constructor(){
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "defaultType", 'json');
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "getDefaultParam", ()=>undefined);
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "defaultResponseHandler", $5fb9e5f2b72fb5e6$export$a16fabbea479f58a);
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "requestDecorator", (a)=>a);
        /**
     * @param {string} method
     * @param {string} url
     * @param {HttpOptions} options
     * @param {boolean} force
     * @param {function(method:string, url:string, options:HttpOptions, request:Request, response:Response?,
     *     error:Error?, data:*?, dataType:string?)} responseHandler
     * @return {string}
     */ $5fb9e5f2b72fb5e6$var$_defineProperty(this, "http", (method, url, options = {}, force = false, responseHandler)=>{
            const { defaultType: defaultType, getDefaultParam: getDefaultParam, requestDecorator: requestDecorator, defaultResponseHandler: defaultResponseHandler } = this;
            const store = (0, $kYBQo.default)();
            if (!store) throw new Error('setStore() must be called before using methods.');
            const name = options.name || `${method}|${url}`;
            delete options.name;
            const decoratedOptions = requestDecorator(options);
            if (!force) {
                const request = this.getRequest(name, null, false, false);
                if (!request?.processed && $5fb9e5f2b72fb5e6$var$requestsMatch(request, method, url, decoratedOptions)) // Don't run the second query if there is a matching one already running.
                return name;
            }
            store.dispatch((0, $aW9Iw.httpAction)(name, {
                method: method,
                url: url,
                type: decoratedOptions.type || defaultType,
                options: decoratedOptions,
                getDefaultParam: getDefaultParam,
                responseHandler: responseHandler || defaultResponseHandler,
                force: force
            }));
            return name;
        });
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "get", (url, options = {}, force = false, responseHandler)=>this.http('get', url, options, force, responseHandler));
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "post", (url, options, force = false, responseHandler)=>this.http('post', url, options, force, responseHandler));
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "put", (url, options, force = false, responseHandler)=>this.http('put', url, options, force, responseHandler));
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "delete", (url, options, force = false, responseHandler)=>this.http('delete', url, options, force, responseHandler));
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "getRequest", (name, state = null, unprocessedOnly = true, processOnRetrieval = true)=>{
            if (!name) return undefined;
            const request = (0, $4H3d6.requestSelector)(state || (0, $kYBQo.default)().getState(), name);
            if (unprocessedOnly && request?.processed) return undefined;
            request && request.completed && processOnRetrieval && this.processRequest(name);
            return request;
        });
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "flush", (nameOrRequestObject)=>{
            (0, $kYBQo.default)().dispatch((0, $aW9Iw.flushAction)(nameOrRequestObject.name || nameOrRequestObject));
        });
        $5fb9e5f2b72fb5e6$var$_defineProperty(this, "processRequest", (name)=>{
            (0, $kYBQo.default)().dispatch((0, $aW9Iw.processAction)(name));
        });
    }
}
const $5fb9e5f2b72fb5e6$var$http = new $5fb9e5f2b72fb5e6$export$2a5b27776dbece47();
var $5fb9e5f2b72fb5e6$export$2e2bcd8739ae039 = $5fb9e5f2b72fb5e6$var$http;

});
parcelRegister("aW9Iw", function(module, exports) {

$parcel$export(module.exports, "httpAction", () => $7f66dbcc7324eef1$export$bce51ec6b123d187);
$parcel$export(module.exports, "processAction", () => $7f66dbcc7324eef1$export$a79ad4cfcdb1c750);
$parcel$export(module.exports, "flushAction", () => $7f66dbcc7324eef1$export$b353420df31ceb2f);

var $hUF7r = parcelRequire("hUF7r");
parcelRequire("ktt7r");
var $6i2Q5 = parcelRequire("6i2Q5");
const $7f66dbcc7324eef1$var$normalizeBody = (body)=>body instanceof Blob || typeof body === 'string' || typeof body !== 'object' ? body : JSON.stringify(body);
const $7f66dbcc7324eef1$var$applyPathParams = (url, pathParams, getDefaultParam)=>url.replace(/{([^}]+)}/g, (_, param)=>{
        var _pathParams$param;
        return (_pathParams$param = pathParams[param]) !== null && _pathParams$param !== void 0 ? _pathParams$param : getDefaultParam(param);
    });
const $7f66dbcc7324eef1$var$getDataType = (response)=>{
    const contentType = response.headers.get('Content-Type')?.split(/;/)[0];
    if (!contentType || response.status === 204) return null;
    if (contentType === 'application/json') return 'json';
    if (/^text\//.test(contentType)) return 'text';
    return 'blob';
};
const $7f66dbcc7324eef1$var$getMimeType = (type)=>{
    switch(type){
        case 'json':
            return 'application/json';
        case 'blob':
            return 'application/octet-stream';
        default:
            return 'text/plain';
    }
};
const $7f66dbcc7324eef1$var$httpRequest = ({ method: method, url: url, type: type, options: { body: body, query: query = {}, pathParams: pathParams = {}, ...options }, getDefaultParam: getDefaultParam, force: force })=>fetch($7f66dbcc7324eef1$var$applyPathParams(url, pathParams, getDefaultParam) + (0, $6i2Q5.default)({
        ...query,
        ...force ? {
            force: Date.now()
        } : {}
    }), {
        method: method,
        body: $7f66dbcc7324eef1$var$normalizeBody(body),
        ...options,
        headers: {
            'Content-Type': $7f66dbcc7324eef1$var$getMimeType(type),
            ...options.headers
        }
    });
const $7f66dbcc7324eef1$var$processRequest = async (dispatch, name, { method: method, url: url, type: type, options: options, getDefaultParam: getDefaultParam, responseHandler: responseHandler, force: force })=>{
    const abortController = new AbortController();
    const request = $7f66dbcc7324eef1$var$httpRequest({
        method: method,
        url: url,
        type: type,
        options: {
            signal: abortController.signal,
            ...options
        },
        getDefaultParam: getDefaultParam,
        force: force
    });
    dispatch({
        type: (0, $hUF7r.REQUEST_STARTED),
        name: name,
        method: method,
        url: url,
        options: options,
        abortController: abortController,
        request: request
    });
    let response;
    try {
        response = await request;
        const dataType = $7f66dbcc7324eef1$var$getDataType(response);
        let data = response.status !== 204 && dataType && await response[dataType]();
        if (dataType === 'json' && data.data) ({ data: data } = data);
        if (dataType && type && dataType !== type) {
            const error = new Error(`Expected data type ${type}, but type was ${dataType}`);
            dispatch({
                type: (0, $hUF7r.REQUEST_ERRORED),
                name: name,
                error: error.message,
                response: response,
                request: request,
                data: data,
                status: response.status
            });
            responseHandler({
                method: method,
                url: url,
                options: options,
                request: request,
                response: response,
                error: error,
                data: data,
                dataType: dataType
            });
        } else {
            dispatch({
                type: (0, $hUF7r.REQUEST_COMPLETED),
                name: name,
                response: response,
                request: request,
                data: data,
                dataType: dataType,
                status: response.status,
                ok: response.status >= 200 && response.status <= 299,
                completed: true
            });
            responseHandler({
                method: method,
                url: url,
                options: options,
                request: request,
                response: response,
                data: data,
                dataType: dataType
            });
        }
    } catch (error) {
        // Note: Aborting will cause this to trigger, but the reducer will see it was an old request
        //  and not actually store the error.
        dispatch({
            type: (0, $hUF7r.REQUEST_ERRORED),
            name: name,
            error: error,
            request: request,
            response: response
        });
        !abortController.signal.aborted && responseHandler({
            method: method,
            url: url,
            options: options,
            request: request,
            response: response,
            error: error
        });
    }
};
const $7f66dbcc7324eef1$export$bce51ec6b123d187 = (name, { method: method, url: url, type: type, options: options = {}, getDefaultParam: getDefaultParam = ()=>undefined, responseHandler: responseHandler = ()=>{}, force: force })=>(dispatch)=>{
        $7f66dbcc7324eef1$var$processRequest(dispatch, name, {
            method: method,
            url: url,
            type: type,
            options: options,
            getDefaultParam: getDefaultParam,
            responseHandler: responseHandler,
            force: force
        }).catch((error)=>dispatch({
                type: (0, $hUF7r.REQUEST_ERRORED),
                name: name,
                error: error
            }));
    };
const $7f66dbcc7324eef1$export$a79ad4cfcdb1c750 = (name)=>(dispatch)=>{
        dispatch({
            type: (0, $hUF7r.REQUEST_PROCESSED),
            name: name
        });
    };
const $7f66dbcc7324eef1$export$b353420df31ceb2f = (name)=>(dispatch)=>{
        dispatch({
            type: (0, $hUF7r.REQUEST_FLUSH),
            name: name
        });
    };

});
parcelRegister("ktt7r", function(module, exports) {

$parcel$export(module.exports, "getQueryParam", () => (parcelRequire("1pb1q")).default);
$parcel$export(module.exports, "getQueryParams", () => (parcelRequire("iXmyP")).default);
$parcel$export(module.exports, "hasQueryParam", () => (parcelRequire("68nwT")).default);
$parcel$export(module.exports, "toQueryString", () => (parcelRequire("6i2Q5")).default);

var $1pb1q = parcelRequire("1pb1q");

var $iXmyP = parcelRequire("iXmyP");

var $68nwT = parcelRequire("68nwT");

var $6i2Q5 = parcelRequire("6i2Q5");

});
parcelRegister("1pb1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1060acfbfb821719$export$2e2bcd8739ae039);

var $iXmyP = parcelRequire("iXmyP");
const $1060acfbfb821719$var$getQueryParam = (name)=>(0, $iXmyP.default)()[name];
var $1060acfbfb821719$export$2e2bcd8739ae039 = $1060acfbfb821719$var$getQueryParam;

});
parcelRegister("iXmyP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dccf3ccd9362104d$export$2e2bcd8739ae039);
const $dccf3ccd9362104d$var$getQueryParams = ()=>location.search.length ? location.search.slice(1).split(/&/g).map((v)=>v.split(/=/)).reduce((obj, [key, value])=>// if value is undefined, it means it's a boolean parameter, so we'll just put true
        Object.assign(obj, {
            [key]: value !== null && value !== void 0 ? value : true
        }), {}) : {};
var $dccf3ccd9362104d$export$2e2bcd8739ae039 = $dccf3ccd9362104d$var$getQueryParams;

});


parcelRegister("68nwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4775bde47a2da9df$export$2e2bcd8739ae039);

var $iXmyP = parcelRequire("iXmyP");
const $4775bde47a2da9df$var$hasQueryParam = (name)=>Object.prototype.hasOwnProperty.call((0, $iXmyP.default)(), name);
var $4775bde47a2da9df$export$2e2bcd8739ae039 = $4775bde47a2da9df$var$hasQueryParam;

});

parcelRegister("6i2Q5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4946a04a0984dfdd$export$2e2bcd8739ae039);
const $4946a04a0984dfdd$var$toQueryString = (params)=>{
    const str = Object.entries(params).map(([key, value])=>`${key}=${value}`).join('&');
    return str ? `?${str}` : '';
};
var $4946a04a0984dfdd$export$2e2bcd8739ae039 = $4946a04a0984dfdd$var$toQueryString;

});



parcelRegister("4H3d6", function(module, exports) {

$parcel$export(module.exports, "requestSelector", () => $36adab1ae253b598$export$5f6c8501e4f20694);
const $36adab1ae253b598$export$5f6c8501e4f20694 = (state, name)=>(state.http || state)[name];

});


parcelRegister("bDGmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $87943318f6ef2da1$export$2e2bcd8739ae039);
parcelRequire("800sp");
var $4jdI8 = parcelRequire("4jdI8");
var $jJTNo = parcelRequire("jJTNo");
var $lPSdM = parcelRequire("lPSdM");

var $ehGjl = parcelRequire("ehGjl");
function $87943318f6ef2da1$var$_defineProperty(e, r, t) {
    return (r = $87943318f6ef2da1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $87943318f6ef2da1$var$_toPropertyKey(t) {
    var i = $87943318f6ef2da1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $87943318f6ef2da1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $87943318f6ef2da1$export$2e2bcd8739ae039 extends (0, $lPSdM.LitElement) {
    static get styles() {
        return (0, $4jdI8.css)`
      a {
        color: inherit;
        text-decoration: inherit;
      }
    `;
    }
    static get properties() {
        return {
            href: {
                type: String
            }
        };
    }
    constructor(){
        super();
        $87943318f6ef2da1$var$_defineProperty(this, "handleClick", (event)=>{
            const target = event.currentTarget.shadowRoot?.querySelector('a') || event.currentTarget;
            event.stopPropagation();
            event.preventDefault();
            (0, $ehGjl.default).navigate(target.href.replace(document.baseURI, ''));
        });
        this.addEventListener('click', this.handleClick);
    }
    render() {
        const { href: href, handleClick: handleClick } = this;
        return (0, $jJTNo.html)`
      <a href=${href} @click=${handleClick}>
        <slot></slot>
      </a>
    `;
    }
}
$87943318f6ef2da1$var$_defineProperty($87943318f6ef2da1$export$2e2bcd8739ae039, "router", undefined);
customElements.define('rad-link', $87943318f6ef2da1$export$2e2bcd8739ae039);

});
parcelRegister("800sp", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("jJTNo")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("lPSdM")).LitElement);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("4jdI8")).unsafeCSS);
parcelRequire("3qR54");
parcelRequire("jJTNo");
parcelRequire("lPSdM");
parcelRequire("8FVzH");

});
parcelRegister("3qR54", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $27fcf98b67c2a783$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("4jdI8")).unsafeCSS);

var $4jdI8 = parcelRequire("4jdI8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $27fcf98b67c2a783$var$s;
const $27fcf98b67c2a783$var$e = window, $27fcf98b67c2a783$var$r = $27fcf98b67c2a783$var$e.trustedTypes, $27fcf98b67c2a783$var$h = $27fcf98b67c2a783$var$r ? $27fcf98b67c2a783$var$r.emptyScript : "", $27fcf98b67c2a783$var$o = $27fcf98b67c2a783$var$e.reactiveElementPolyfillSupport, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $27fcf98b67c2a783$var$l = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
}, $27fcf98b67c2a783$var$d = "finalized";
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $27fcf98b67c2a783$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $27fcf98b67c2a783$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d)) return !1;
        this[$27fcf98b67c2a783$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $4jdI8.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $4jdI8.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $4jdI8.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $27fcf98b67c2a783$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $27fcf98b67c2a783$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d] = !0, $27fcf98b67c2a783$export$c7c07a37856565d.elementProperties = new Map, $27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $27fcf98b67c2a783$var$o || $27fcf98b67c2a783$var$o({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), (null !== ($27fcf98b67c2a783$var$s = $27fcf98b67c2a783$var$e.reactiveElementVersions) && void 0 !== $27fcf98b67c2a783$var$s ? $27fcf98b67c2a783$var$s : $27fcf98b67c2a783$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("4jdI8", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", () => $3233927aa82734f9$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $3233927aa82734f9$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $3233927aa82734f9$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $3233927aa82734f9$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = window, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$n = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(n, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, n)=>{
    $3233927aa82734f9$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $3233927aa82734f9$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("jJTNo", function(module, exports) {

$parcel$export(module.exports, "html", () => $e5ed8027d647799b$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $e5ed8027d647799b$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $e5ed8027d647799b$export$45b790e32b2810ee);
$parcel$export(module.exports, "render", () => $e5ed8027d647799b$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e5ed8027d647799b$var$t;
const $e5ed8027d647799b$var$i = window, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i.trustedTypes, $e5ed8027d647799b$var$e = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$o = "$lit$", $e5ed8027d647799b$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e5ed8027d647799b$var$l = "?" + $e5ed8027d647799b$var$n, $e5ed8027d647799b$var$h = `<${$e5ed8027d647799b$var$l}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$u = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$c = Array.isArray, $e5ed8027d647799b$var$v = (t)=>$e5ed8027d647799b$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e5ed8027d647799b$var$a = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$_ = /-->/g, $e5ed8027d647799b$var$m = />/g, $e5ed8027d647799b$var$p = RegExp(`>|${$e5ed8027d647799b$var$a}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$a}*=${$e5ed8027d647799b$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$g = /'/g, $e5ed8027d647799b$var$$ = /"/g, $e5ed8027d647799b$var$y = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$w(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$w(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$E = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129, null, !1);
function $e5ed8027d647799b$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$e ? $e5ed8027d647799b$var$e.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e5ed8027d647799b$var$f ? "!--" === c[1] ? u = $e5ed8027d647799b$var$_ : void 0 !== c[1] ? u = $e5ed8027d647799b$var$m : void 0 !== c[2] ? ($e5ed8027d647799b$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $e5ed8027d647799b$var$p) : void 0 !== c[3] && (u = $e5ed8027d647799b$var$p) : u === $e5ed8027d647799b$var$p ? ">" === c[0] ? (u = null != l ? l : $e5ed8027d647799b$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $e5ed8027d647799b$var$p : '"' === c[3] ? $e5ed8027d647799b$var$$ : $e5ed8027d647799b$var$g) : u === $e5ed8027d647799b$var$$ || u === $e5ed8027d647799b$var$g ? u = $e5ed8027d647799b$var$p : u === $e5ed8027d647799b$var$_ || u === $e5ed8027d647799b$var$m ? u = $e5ed8027d647799b$var$f : (u = $e5ed8027d647799b$var$p, l = void 0);
        const w = u === $e5ed8027d647799b$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $e5ed8027d647799b$var$o + s.slice(v) + $e5ed8027d647799b$var$n + w) : s + $e5ed8027d647799b$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $e5ed8027d647799b$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e5ed8027d647799b$var$V(t, i);
        if (this.el = $e5ed8027d647799b$var$N.createElement(a, e), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e5ed8027d647799b$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e5ed8027d647799b$var$o) || i.startsWith($e5ed8027d647799b$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e5ed8027d647799b$var$o).split($e5ed8027d647799b$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e5ed8027d647799b$var$H : "?" === i[1] ? $e5ed8027d647799b$var$L : "@" === i[1] ? $e5ed8027d647799b$var$z : $e5ed8027d647799b$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e5ed8027d647799b$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e5ed8027d647799b$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e5ed8027d647799b$var$u()), $e5ed8027d647799b$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e5ed8027d647799b$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e5ed8027d647799b$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e5ed8027d647799b$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e5ed8027d647799b$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $e5ed8027d647799b$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e5ed8027d647799b$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e5ed8027d647799b$var$r).importNode(s, !0);
        $e5ed8027d647799b$var$C.currentNode = o;
        let n = $e5ed8027d647799b$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $e5ed8027d647799b$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $e5ed8027d647799b$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $e5ed8027d647799b$var$C.nextNode(), l++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$d(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e5ed8027d647799b$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e5ed8027d647799b$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$E.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$E.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    T(t) {
        $e5ed8027d647799b$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.k($e5ed8027d647799b$var$u()), this.k($e5ed8027d647799b$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e5ed8027d647799b$var$S(this, t, i, 0), n = !$e5ed8027d647799b$var$d(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e5ed8027d647799b$var$S(this, e[s + l], i, l), h === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e5ed8027d647799b$var$d(h) || h !== this._$AH[l]), h === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e5ed8027d647799b$var$I = $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.emptyScript : "";
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e5ed8027d647799b$var$I) : this.element.removeAttribute(this.name);
    }
}
class $e5ed8027d647799b$var$z extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e5ed8027d647799b$var$S(this, t, i, 0)) && void 0 !== s ? s : $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e5ed8027d647799b$export$45b790e32b2810ee && e !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (e === $e5ed8027d647799b$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    O: $e5ed8027d647799b$var$o,
    P: $e5ed8027d647799b$var$n,
    A: $e5ed8027d647799b$var$l,
    C: 1,
    M: $e5ed8027d647799b$var$V,
    L: $e5ed8027d647799b$var$M,
    R: $e5ed8027d647799b$var$v,
    D: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    V: $e5ed8027d647799b$var$k,
    H: $e5ed8027d647799b$var$L,
    N: $e5ed8027d647799b$var$z,
    U: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$Z
}, $e5ed8027d647799b$var$B = $e5ed8027d647799b$var$i.litHtmlPolyfillSupport;
null == $e5ed8027d647799b$var$B || $e5ed8027d647799b$var$B($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), (null !== ($e5ed8027d647799b$var$t = $e5ed8027d647799b$var$i.litHtmlVersions) && void 0 !== $e5ed8027d647799b$var$t ? $e5ed8027d647799b$var$t : $e5ed8027d647799b$var$i.litHtmlVersions = []).push("2.8.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("lPSdM", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("4jdI8")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("3qR54")).ReactiveElement);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("4jdI8")).unsafeCSS);
$parcel$export(module.exports, "html", () => (parcelRequire("jJTNo")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("jJTNo")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("jJTNo")).render);

$parcel$export(module.exports, "LitElement", () => $fe586ba0757c37f7$export$3f2f9f5909897157);

var $3qR54 = parcelRequire("3qR54");

var $jJTNo = parcelRequire("jJTNo");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fe586ba0757c37f7$var$l, $fe586ba0757c37f7$var$o;
const $fe586ba0757c37f7$export$8bf27daf9e8907c9 = (0, $3qR54.ReactiveElement);
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $3qR54.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $jJTNo.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $jJTNo.noChange;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157.finalized = !0, $fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, null === ($fe586ba0757c37f7$var$l = globalThis.litElementHydrateSupport) || void 0 === $fe586ba0757c37f7$var$l || $fe586ba0757c37f7$var$l.call(globalThis, {
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$n = globalThis.litElementPolyfillSupport;
null == $fe586ba0757c37f7$var$n || $fe586ba0757c37f7$var$n({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($fe586ba0757c37f7$var$o = globalThis.litElementVersions) && void 0 !== $fe586ba0757c37f7$var$o ? $fe586ba0757c37f7$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("8FVzH", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;

});


parcelRegister("ehGjl", function(module, exports) {

$parcel$export(module.exports, "generate", () => $a66379539387d717$export$80d376111cc09ad7);
$parcel$export(module.exports, "default", () => $a66379539387d717$export$2e2bcd8739ae039);

var $eWjQq = parcelRequire("eWjQq");

var $kL15l = parcelRequire("kL15l");

var $04gBu = parcelRequire("04gBu");

var $1XhrH = parcelRequire("1XhrH");
parcelRequire("ktt7r");
var $iXmyP = parcelRequire("iXmyP");

var $4hATe = parcelRequire("4hATe");
const $a66379539387d717$var$router = new class {
    constructor(){
        this.baseUri = document.baseURI.replace(/\/?$/, '');
        window.addEventListener('popstate', ()=>{
            this.resolve();
        });
    }
    pause() {
        this.paused = true;
    }
    resume() {
        this.paused = false;
        this.resolve();
    }
    navigate(path) {
        if (!this.beforeCallback) {
            this.doNavigate(path);
            return;
        }
        this.beforeCallback((resolve = true)=>{
            resolve && this.doNavigate(path);
        });
    }
    doNavigate(path) {
        history.pushState('', '', path);
        !this.paused && this.resolve();
    }
    generate(routeName, params) {
        const route = this.routes.find(({ as: as })=>as === routeName);
        if (!route) return undefined;
        return Object.entries(params).reduce((str, [key, value])=>str.replace(new RegExp(`:${key}(/?)`, 'g'), `${value}$1`), route.route);
    }
    resolve() {
        const path = document.location.href.replace(this.baseUri, '').replace(/\/?([#?].*)?$/, '') || '/';
        const route = this.routes.find(({ pattern: pattern })=>pattern.test(path));
        if (!route) {
            this.notFoundCallback();
            return;
        }
        const { pattern: pattern, uses: uses } = route;
        const { groups: params } = path.match(pattern);
        const query = (0, $iXmyP.default)();
        uses(params, query);
    }
    on(routes) {
        this.routes = Object.entries(routes).map(([route, { as: as, uses: uses }])=>({
                route: route,
                pattern: new RegExp(`^${route.replace(/\//, '\\/').replace(/:([^/]+)!/g, '(?<$1>.+)').replace(/:([^/]+)/g, '(?<$1>[^\\/]+)')}$`),
                as: as,
                uses: uses
            }));
        return this;
    }
    notFound(notFoundCallback) {
        this.notFoundCallback = notFoundCallback;
        return this;
    }
    hooks({ before: before }) {
        this.beforeCallback = before;
        return this;
    }
}();
const $a66379539387d717$export$80d376111cc09ad7 = (routeName, givenParams = {})=>{
    const { route: route } = (0, $04gBu.default)[routeName];
    const params = [
        ...route.matchAll(/:([^/]+)/g)
    ].map((a)=>a[1]).reduce((result, paramName)=>{
        var _givenParams$paramNam;
        return {
            ...result,
            [paramName]: (_givenParams$paramNam = givenParams[paramName]) !== null && _givenParams$paramNam !== void 0 ? _givenParams$paramNam : (0, $1XhrH.default)(paramName)
        };
    }, {});
    return `.${$a66379539387d717$var$router.generate(routeName, params)}`;
};
const $a66379539387d717$var$changePageUses = (page, filePath)=>(params, query)=>{
        (0, $eWjQq.store).dispatch((0, $kL15l.navigate)(page, filePath, params, query));
    };
const $a66379539387d717$var$forwardPageUses = (forward)=>(params, query)=>{
        const queryString = query ? (0, $4hATe.default)(query) : '';
        $a66379539387d717$var$router.navigate(`${$a66379539387d717$export$80d376111cc09ad7(forward, params)}${queryString}`);
    };
const $a66379539387d717$var$changePage = (page, filePath)=>({
        as: page,
        uses: $a66379539387d717$var$changePageUses(page, filePath)
    });
const $a66379539387d717$var$forwardPage = (page, forward)=>({
        as: page,
        uses: $a66379539387d717$var$forwardPageUses(forward)
    });
const $a66379539387d717$var$buildRoutes = (routes)=>Object.entries(routes).filter(([, { notFound: notFound }])=>!notFound).reduce((result, [routeName, { view: view, route: route, forward: forward }])=>({
            ...result,
            [route]: view ? $a66379539387d717$var$changePage(routeName, view) : $a66379539387d717$var$forwardPage(routeName, forward)
        }), {});
const $a66379539387d717$var$notFoundRoute = Object.entries((0, $04gBu.default)).find(([, { notFound: notFound }])=>notFound);
const $a66379539387d717$var$hooks = {
    before: (doneCallback)=>{
        const done = (goToNext = true)=>{
            doneCallback(goToNext);
        };
        const event = new CustomEvent('beforenav', {
            cancelable: true,
            detail: {
                done: done
            }
        });
        if (window.dispatchEvent(event)) done();
    }
};
$a66379539387d717$var$router.on($a66379539387d717$var$buildRoutes((0, $04gBu.default))).notFound($a66379539387d717$var$changePageUses($a66379539387d717$var$notFoundRoute[0], $a66379539387d717$var$notFoundRoute[1].view)).hooks($a66379539387d717$var$hooks).resolve();
var $a66379539387d717$export$2e2bcd8739ae039 = $a66379539387d717$var$router;

});
parcelRegister("kL15l", function(module, exports) {

$parcel$export(module.exports, "disableVerify", () => $f1c909f163fa7b25$export$6ab5d8595c27f54c);
$parcel$export(module.exports, "enableVerify", () => $f1c909f163fa7b25$export$9d2dc33939c8435);
$parcel$export(module.exports, "showOverlay", () => $f1c909f163fa7b25$export$85f1bfb258290b46);
$parcel$export(module.exports, "hideOverlay", () => $f1c909f163fa7b25$export$e7f12c9836083937);
$parcel$export(module.exports, "updateConfig", () => $f1c909f163fa7b25$export$2eaf9172a83ee9e7);
$parcel$export(module.exports, "updateMe", () => $f1c909f163fa7b25$export$8ddaddf355aae59c);
$parcel$export(module.exports, "updateSettings", () => $f1c909f163fa7b25$export$f558026a994b6051);
$parcel$export(module.exports, "updatePatient", () => $f1c909f163fa7b25$export$a4237eede6ad7dfc);
$parcel$export(module.exports, "navigate", () => $f1c909f163fa7b25$export$ff7962acd6052c28);

var $fp8Uu = parcelRequire("fp8Uu");
const $f1c909f163fa7b25$export$6ab5d8595c27f54c = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.VERIFY_DISABLED),
            disabled: true
        });
    };
const $f1c909f163fa7b25$export$9d2dc33939c8435 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.VERIFY_DISABLED),
            disabled: false
        });
    };
const $f1c909f163fa7b25$export$85f1bfb258290b46 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.SHOW_OVERLAY),
            show: true
        });
    };
const $f1c909f163fa7b25$export$e7f12c9836083937 = ()=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.SHOW_OVERLAY),
            show: false
        });
    };
const $f1c909f163fa7b25$export$2eaf9172a83ee9e7 = (config)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_CONFIG),
            config: config
        });
    };
const $f1c909f163fa7b25$export$8ddaddf355aae59c = (me)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_ME),
            me: me
        });
    };
const $f1c909f163fa7b25$export$f558026a994b6051 = (settings)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_SETTINGS),
            settings: settings
        });
    };
const $f1c909f163fa7b25$export$a4237eede6ad7dfc = (patient)=>(dispatch)=>{
        dispatch({
            type: (0, $fp8Uu.UPDATE_PATIENT),
            patient: patient
        });
    };
const $f1c909f163fa7b25$export$ff7962acd6052c28 = (page, loadFile, params, query)=>(dispatch)=>{
        loadFile();
        dispatch({
            type: (0, $fp8Uu.UPDATE_PAGE),
            page: page,
            params: params,
            query: query
        });
    };

});

parcelRegister("04gBu", function(module, exports) {

$parcel$export(module.exports, "Routes", () => $00cd40fb284c8120$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "default", () => $00cd40fb284c8120$export$2e2bcd8739ae039);
/* global process */ parcelRequire("800sp");
var $jJTNo = parcelRequire("jJTNo");
const $00cd40fb284c8120$export$3565eb3d00ca5a74 = {
    Root: 'root',
    WeeklyCheckLanding: 'weekly-check-landing',
    WeeklyCheckOrganization: 'weekly-check-organization',
    WeeklyCheckPatient: 'weekly-check-patient',
    NotFound404: '404-not-found',
    OrganizationSettingsMain: 'organization-settings-main',
    OrganizationSettingsSub: 'organization-settings-sub',
    Document: 'document',
    Image: 'image',
    Landing: 'landing',
    Login: 'login',
    Logout: 'logout',
    AdminUsers: 'auth-users',
    AdminOrganizations: 'auth-organizations',
    AdminPermissions: 'auth-permissions',
    AdminRoot: 'landing-root',
    AdminLanding: 'landing-admin',
    ResetPassword: 'reset-password',
    ForgotPassword: 'forgot-password',
    BlankImage: 'images-not-loaded',
    Batch: 'batch',
    Image2: 'image2',
    SupportImageViewer: 'support-image-viewer',
    SupportImageViewerIndex: 'support-image-viewer-index'
};



















const $00cd40fb284c8120$var$routes = {
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Root]: {
        route: '/',
        forward: $00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckLanding
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckLanding]: {
        route: '/weekly-check',
        view: ()=>(parcelRequire("lbcro")),
        title: 'WeeklyCheck',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view></weekly-plan-check-view>`
    },
    'organization-without-patient': {
        route: '/weekly-check/:organization',
        forward: $00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckOrganization
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckPatient]: {
        route: '/weekly-check/:organization/patient/:patient',
        view: ()=>(parcelRequire("lbcro")),
        title: 'WeeklyCheck',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view></weekly-plan-check-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.WeeklyCheckOrganization]: {
        route: '/weekly-check/:organization/patient',
        view: ()=>(parcelRequire("lbcro")),
        title: 'WeeklyCheck',
        render: ()=>(0, $jJTNo.html)`<weekly-plan-check-view></weekly-plan-check-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.OrganizationSettingsMain]: {
        route: '/weekly-check/:organization/settings',
        view: ()=>(parcelRequire("nfLck")),
        title: 'WeeklyCheck Settings',
        render: ()=>(0, $jJTNo.html)`<settings-view></settings-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.OrganizationSettingsSub]: {
        route: '/weekly-check/:organization/settings/:page',
        view: ()=>(parcelRequire("nfLck")),
        title: 'WeeklyCheck Settings',
        render: ()=>(0, $jJTNo.html)`<settings-view></settings-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Document]: {
        route: '/weekly-check/:organization/document/:documentType/:documentId',
        view: ()=>(parcelRequire("fwHr2")),
        title: 'WeeklyCheck - Document',
        render: ()=>(0, $jJTNo.html)`<document-view></document-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Image]: {
        route: '/weekly-check/:organization/image/:patient/:planSer/:fraction/:groupIndex',
        view: ()=>(parcelRequire("2ohBh")),
        title: 'WeeklyCheck - Snowflake',
        render: ()=>(0, $jJTNo.html)`<snowflake-view></snowflake-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.NotFound404]: {
        notFound: true,
        view: ()=>(parcelRequire("bEmB9")),
        title: '404 Not Found',
        render: ()=>(0, $jJTNo.html)`<error-404-view></error-404-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Login]: {
        route: '/auth/login',
        view: ()=>(parcelRequire("bJq1a")),
        title: 'Login',
        render: ()=>(0, $jJTNo.html)`<login-view></login-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Logout]: {
        route: '/auth/logout',
        forward: '/login'
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminRoot]: {
        route: '/auth',
        view: ()=>(parcelRequire("1a23X")),
        title: 'Admin - Users',
        render: ()=>(0, $jJTNo.html)`<users-view></users-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminLanding]: {
        route: '/auth/:organization',
        forward: $00cd40fb284c8120$export$3565eb3d00ca5a74.AdminUsers
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminUsers]: {
        route: '/auth/:organization/users',
        view: ()=>(parcelRequire("1a23X")),
        title: 'Admin - Users',
        render: ()=>(0, $jJTNo.html)`<users-view></users-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminOrganizations]: {
        route: '/auth/:organization/organizations',
        view: ()=>(parcelRequire("X6sDD")),
        title: 'Admin - Organizations',
        render: ()=>(0, $jJTNo.html)`<organizations-view></organizations-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.AdminPermissions]: {
        route: '/auth/:organization/permissions',
        view: ()=>(parcelRequire("bvcGj")),
        title: 'Admin - Permissions',
        render: ()=>(0, $jJTNo.html)`<permissions-view></permissions-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.ResetPassword]: {
        route: '/auth/password/reset',
        view: ()=>(parcelRequire("gPUTI")),
        title: 'Password Reset',
        render: ()=>(0, $jJTNo.html)`<password-reset-view></password-reset-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.ForgotPassword]: {
        route: '/auth/password/forgot',
        view: ()=>(parcelRequire("h3KHP")),
        title: 'Forgot Password',
        render: ()=>(0, $jJTNo.html)`<password-forgot-view></password-forgot-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.BlankImage]: {
        route: '/weekly-check/:organization/image/:patient/blank',
        view: ()=>(parcelRequire("hImB1")),
        title: 'Images Not Loaded',
        render: ()=>(0, $jJTNo.html)`<blank-image-view></blank-image-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.Batch]: {
        route: '/weekly-check/:organization/batch',
        view: ()=>(parcelRequire("01PLs")),
        title: 'Batch Approval',
        render: ()=>(0, $jJTNo.html)`<batch-view></batch-view>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.SupportImageViewer]: {
        route: '/support/image',
        view: ()=>(parcelRequire("8ELqx")),
        title: 'Snowflake Image Viewer',
        render: ()=>(0, $jJTNo.html)`<support-image-viewer></support-image-viewer>`
    },
    [$00cd40fb284c8120$export$3565eb3d00ca5a74.SupportImageViewerIndex]: {
        route: '/support/image/:index',
        view: ()=>(parcelRequire("8ELqx")),
        title: 'Snowflake Image Viewer',
        render: ()=>(0, $jJTNo.html)`<support-image-viewer></support-image-viewer>`
    }
};
var $00cd40fb284c8120$export$2e2bcd8739ae039 = $00cd40fb284c8120$var$routes;

});
parcelRegister("lbcro", function(module, exports) {
module.exports = Promise.all([
    import("188LA"),
    import("7PysB"),
    import("7vsen"),
    import("3AIig")
]).then(()=>parcelRequire('gK1K3'));

});

parcelRegister("nfLck", function(module, exports) {
module.exports = Promise.all([
    import("7PysB"),
    import("7vsen"),
    import("8yhmn")
]).then(()=>parcelRequire('lPst4'));

});

parcelRegister("fwHr2", function(module, exports) {
module.exports = Promise.all([
    import("188LA"),
    import("8cvZT")
]).then(()=>parcelRequire('dHSOR'));

});

parcelRegister("2ohBh", function(module, exports) {
module.exports = Promise.all([
    import("5sJzW"),
    import("l3vkL")
]).then(()=>parcelRequire('8szhW'));

});

parcelRegister("bEmB9", function(module, exports) {
module.exports = import("cDAc7").then(()=>parcelRequire('5TkQv'));

});

parcelRegister("bJq1a", function(module, exports) {
module.exports = import("3rzX7").then(()=>parcelRequire('ktuva'));

});

parcelRegister("1a23X", function(module, exports) {
module.exports = Promise.all([
    import("7vsen"),
    import("2d8NE")
]).then(()=>parcelRequire('8GIM0'));

});

parcelRegister("X6sDD", function(module, exports) {
module.exports = Promise.all([
    import("7vsen"),
    import("hTIZi")
]).then(()=>parcelRequire('52UpF'));

});

parcelRegister("bvcGj", function(module, exports) {
module.exports = Promise.all([
    import("7vsen"),
    import("fDozm")
]).then(()=>parcelRequire('4NqXt'));

});

parcelRegister("gPUTI", function(module, exports) {
module.exports = import("2gm4U").then(()=>parcelRequire('k3K1x'));

});

parcelRegister("h3KHP", function(module, exports) {
module.exports = import("5Z6NH").then(()=>parcelRequire('bPywh'));

});

parcelRegister("hImB1", function(module, exports) {
module.exports = import("bq3xn").then(()=>parcelRequire('20TqA'));

});

parcelRegister("01PLs", function(module, exports) {
module.exports = Promise.all([
    import("7PysB"),
    import("7vsen"),
    import("ctbVe")
]).then(()=>parcelRequire('3mgaY'));

});

parcelRegister("8ELqx", function(module, exports) {
module.exports = Promise.all([
    import("5sJzW"),
    import("gj4Iz")
]).then(()=>parcelRequire('gTKDi'));

});


parcelRegister("4hATe", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e55d7c780dc12d$export$2e2bcd8739ae039);
/**
 * @param {Object.<string, string>} query The parts of the query to build.
 * @return {string} The constructed string (including the beginning ?) or an empty string if query was empty.
 */ const $31e55d7c780dc12d$var$queryToString = (query)=>{
    const joined = Object.entries(query !== null && query !== void 0 ? query : {}).map(([key, value])=>`${key}=${value}`).join('&');
    return `${joined.length ? '?' : ''}${joined}`;
};
var $31e55d7c780dc12d$export$2e2bcd8739ae039 = $31e55d7c780dc12d$var$queryToString;

});



parcelRegister("caX9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dd44d48c1010ca7$export$2e2bcd8739ae039);

var $4hATe = parcelRequire("4hATe");

var $d1uMe = parcelRequire("d1uMe");

var $3HT2L = parcelRequire("3HT2L");
function $8dd44d48c1010ca7$var$_defineProperty(e, r, t) {
    return (r = $8dd44d48c1010ca7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8dd44d48c1010ca7$var$_toPropertyKey(t) {
    var i = $8dd44d48c1010ca7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8dd44d48c1010ca7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $8dd44d48c1010ca7$var$RadHttpError extends Error {
    constructor(response, message){
        super(message || response?.error?.message);
        $8dd44d48c1010ca7$var$_defineProperty(this, "response", undefined);
        this.response = response;
    }
}
class $8dd44d48c1010ca7$var$RadHttp {
    constructor(){
        /**
     * @typedef RadHttpOptions
     * @property {Object.<string, *>} [headers] Key/value pairs for headers to send with the request.
     * @property {*} [body] The body to pass along with the request. If it is an object, it will be JSON strinigified.
     *   Use rawBody if you want to avoid stringification. Do not use with rawBody.
     * @property {*} [rawBody] The raw body to be passed along exactly as is. Do not use with body.
     * @property {Object.<string, string|number>} [query] Key/value pairs to make up the querystring.
     * @property {Object.<string, *>} [params]
     * @property {'json'|'blob'|'text'|'raw'|'arrayBuffer'} [type] The expected type of the response.
     *   If the expected type does not line up with the expected type, an error is thrown.
     *   If 'raw' is specified, the HttpResponse will have an undefined data and it won't be parsed, so it can be
     *     parsed by the user.
     * @property {Object} [fetchOptions] Additional options to be passed to fetch directly.
     */ /**
     * @typedef RadHttpResponse
     * @type {string} url The actual URL given to fetch.
     * @type {Object} options The actual options given to fetch.
     * @type {Response} response The response from fetch()
     * @type {'json'|'blob'|'text'} type The type of response. It is based on the Content-Type and matches the following:
     *   - application/json => json
     *   - text/* => text
     *   - anything else => blob
     *   If RadHttpOptions.type was specified, it is always this value.
     * @type {Object|Blob|string} data? The parsed data, parsed based on the type,
     *   using either .json(), .blob() or .text()
     * @type {Error} error? The error produced while attempting the request, or returned by the server.
     *   Only possible from the server if type is JSON.
     */ /**
     * @return {Object.<string, string>} The default URL parameters.
     */ $8dd44d48c1010ca7$var$_defineProperty(this, "getDefaultParam", ()=>({}));
    }
    /**
   * Performs an HTTP request.
   * @param {string} verb
   * @param {string} url The URL, which can contain param keys wrapped in curly brackets.
   *   E.g., /patient/{patientId}
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   *
   * Note: option.type defaults to 'json'. If you want a different type, you'll have to manually specify.
   */ async request(verb, url, { body: body, rawBody: rawBody, query: query = {}, params: params = {}, type: type = 'json', fetchOptions: fetchOptions = {} } = {}) {
        try {
            if (body && rawBody) throw new Error('Cannot use "body" and "rawBody" in the same request.');
            if (type && ![
                'json',
                'blob',
                'text',
                'arrayBuffer'
            ].includes(type)) throw new Error(`Unknown expected type: ${type}`);
            const actualUrl = `${(0, $3HT2L.default)(url, params, this.getDefaultParam)}${(0, $4hATe.default)(query)}`;
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: typeof body === 'object' ? JSON.stringify(body) : body,
                method: verb,
                ...fetchOptions
            };
            const response = await fetch(actualUrl, options);
            const [contentType] = response.headers.get('Content-Type')?.split(';') || [];
            let data;
            let error;
            try {
                if (contentType === 'application/json' && (!type || type === 'json')) {
                    var _result$data;
                    const result = await response.json();
                    type = 'json';
                    data = (_result$data = result.data) !== null && _result$data !== void 0 ? _result$data : result;
                    error = result?.error;
                } else if ((0, $d1uMe.default)(contentType, 'text/*') && (!type || type === 'text')) {
                    data = await response.text();
                    type = 'text';
                } else if (type === 'arrayBuffer') {
                    data = await response.arrayBuffer();
                    type = 'arrayBuffer';
                } else if (!type || type === 'blob') {
                    data = await response.blob();
                    type = 'blob';
                }
            } catch (error) {
                throw new $8dd44d48c1010ca7$var$RadHttpError({
                    response: response,
                    url: actualUrl,
                    options: options,
                    error: error
                });
            }
            if (!data) throw $8dd44d48c1010ca7$var$_buildTypeMismatchError.call($8dd44d48c1010ca7$var$RadHttp, type, contentType, response, url, options);
            return {
                url: actualUrl,
                options: options,
                response: response,
                type: type,
                data: data,
                error: error
            };
        } catch (err) {
            console.error(err);
        }
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} [options={}]
   * @return {Promise.<RadHttpResponse>}
   */ async get(url, options = {}) {
        return this.request('GET', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async put(url, options = {}) {
        return this.request('PUT', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async post(url, options = {}) {
        return this.request('POST', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async delete(url, options = {}) {
        return this.request('DELETE', url, options);
    }
    /**
   * @param {string} url
   * @param {RadHttpOptions} options
   * @return {Promise.<RadHttpResponse>}
   */ async patch(url, options = {}) {
        return this.request('PATCH', url, options);
    }
}
function $8dd44d48c1010ca7$var$_buildTypeMismatchError(type, contentType, response, url, options) {
    return new $8dd44d48c1010ca7$var$RadHttpError({
        response: response,
        url: url,
        options: options,
        type: type
    }, `Response expected type ${type}, but Content-Type was ${contentType} which is not acceptable.`);
}
const $8dd44d48c1010ca7$var$radHttp = new $8dd44d48c1010ca7$var$RadHttp();
var $8dd44d48c1010ca7$export$2e2bcd8739ae039 = $8dd44d48c1010ca7$var$radHttp;

});
parcelRegister("d1uMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b33dfd81d91b6e$export$2e2bcd8739ae039);
/**
 * Checks if the content type matches the target type.
 * @param {string} contentType The content type to check. Should not have wildcards.
 * @param {string} targetType The target type, which can contain wildcards.
 * @return {boolean}
 */ const $97b33dfd81d91b6e$var$contentTypeMatches = (contentType, targetType)=>{
    if (!contentType) return false;
    const [actualA, actualB] = contentType.toLowerCase().split('/');
    const [targetA, targetB] = targetType.toLowerCase().split('/');
    return (targetA === '*' || actualA === targetA) && (targetB === '*' || actualB === targetB);
};
var $97b33dfd81d91b6e$export$2e2bcd8739ae039 = $97b33dfd81d91b6e$var$contentTypeMatches;

});

parcelRegister("3HT2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b3015bee8556bf1$export$2e2bcd8739ae039);
const $2b3015bee8556bf1$var$applyParams = (url, params, getDefault)=>url.replace(/{([^}]+)}/g, (_, key)=>{
        const value = params?.[key] || getDefault(key);
        if (!value) throw new Error(`Unknown param: ${key}. Known params: ${Object.keys(params).join(', ')}`);
        return value;
    });
var $2b3015bee8556bf1$export$2e2bcd8739ae039 = $2b3015bee8556bf1$var$applyParams;

});


parcelRegister("2YpSS", function(module, exports) {
module.exports = Promise.all([
    import("cDAc7"),
    import("g490P")
]).then(()=>parcelRequire('5SHaA'));

});


var $1XhrH = parcelRequire("1XhrH");

var $8FBvR = parcelRequire("8FBvR");

var $8dxZ0 = parcelRequire("8dxZ0");

var $bDGmI = parcelRequire("bDGmI");

var $eWjQq = parcelRequire("eWjQq");

var $ehGjl = parcelRequire("ehGjl");
parcelRequire("4Yz9y");
var $bFTPb = parcelRequire("bFTPb");

var $caX9o = parcelRequire("caX9o");
(0, $bFTPb.default)((0, $eWjQq.store));
(0, $bDGmI.default).router = (0, $ehGjl.default);
(0, $8dxZ0.default).getDefaultParam = (0, $1XhrH.default);
(0, $caX9o.default).getDefaultParam = (0, $1XhrH.default);
(0, $8dxZ0.default).defaultResponseHandler = ({ method: method, url: url, options: options, request: request, response: response = null, error: error = null, data: data = null, dataType: dataType = null })=>{
    if (response?.status === 401) {
        window.location.href = `${(0, $8FBvR.configSelector)().loginUrl}?ReturnUrl=${encodeURIComponent(window.location.href)}`;
        return;
    }
    (0, $8dxZ0.defaultResponseHandler)({
        method: method,
        url: url,
        options: options,
        request: request,
        response: response,
        error: error,
        data: data,
        dataType: dataType
    });
};
(0, $8dxZ0.default).requestDecorator = ({ headers: headers = {}, ...rest })=>{
    const organizationId = (0, $8FBvR.organizationIdSelector)();
    organizationId && (headers['x-target-organization-id'] = organizationId);
    return {
        ...rest,
        headers: headers
    };
};

// Must be this style import or else getDefaultParam won't be set in time.
(parcelRequire("2YpSS"));


//# sourceMappingURL=client.1a3e97d1.js.map
